import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import './skeleton.css'


export const SkeletonCommon = (width, height) => {
    return (

        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}

export const SkeletonRole = (width, height) => {
    return (

        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}

export const SkeletonUser = (width, height) => {
    return (
        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}

export const SkeletonButton = (width, height) => {
    return (
        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}

export const SkeletonTask = (width, height) => {
    return (
        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}

export const SkeletonProject = (width, height) => {
    return (
        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}
export const SkeletonProfile1 = (width, height) => {
    return (
        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}

export const SkeletonWorkHours = (width, height) => {
    return (
        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}
export const SkeletonGraph = (width, height) => {
    return (
        <Stack spacing={1}>
            <Skeleton variant="text" width={width} height={height} animation="wave" />
        </Stack>
    )
}